import { CheckCircle2, Clock, Loader2, XCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

import type { DocumentResponse } from '../../types';

const config: Record<
  DocumentResponse['status'],
  {
    label: string;
    variant: 'secondary' | 'default' | 'outline' | 'destructive';
    icon: LucideIcon;
    spin?: boolean;
    className?: string;
  }
> = {
  pending: { label: 'Aguardando', variant: 'secondary', icon: Clock },
  processing: { label: 'Processando', variant: 'default', icon: Loader2, spin: true },
  indexed: {
    label: 'Indexado',
    variant: 'outline',
    icon: CheckCircle2,
    // Verde sutil — leitura rápida de sucesso sem virar semáforo gritante.
    className: 'border-green-600/30 bg-green-600/10 text-green-700 dark:text-green-400',
  },
  failed: { label: 'Falhou', variant: 'destructive', icon: XCircle },
};

interface Props {
  status: DocumentResponse['status'];
}

export function DocumentStatusBadge({ status }: Props) {
  const { label, variant, icon: Icon, spin, className } = config[status];
  return (
    <Badge variant={variant} className={cn('gap-1', className)}>
      <Icon className={cn('size-3', spin && 'animate-spin')} />
      {label}
    </Badge>
  );
}
